/**
 * Re-exports del contrato de filtros + resolución de tilesets de puntos.
 *
 * Polígonos: índice prod (low por provincia / high por departamento).
 * Puntos (`parcelas_puntos`): un tileset por provincia, z0–12, resuelto desde
 * el mismo `pmtiles_index.json`. Nada hardcodeado por provincia.
 */

export {
  createEmptyParcelFilters,
  countActiveParcelFilters,
  getFilterPanelGroups,
  getAppliedFilterChips,
  countActiveFiltersInGroup,
} from './parcelFilterContract';

export { buildParcelFilterMatchExpression } from './parcelFilterMatch';

export const PARCEL_POINTS_SOURCE_LAYER = 'parcelas_puntos';

export const parcelPointsSourceId = (tilesetId) => `parcel-points-${tilesetId}`;
export const parcelPointsLayerId = (tilesetId) => `parcel-points-${tilesetId}-circle`;

/**
 * ¿La entrada del índice es un tileset de puntos? El loader de polígonos debe
 * excluirlas: su `source-layer` es `parcelas_puntos`, no `parcelas`.
 */
export const isParcelPointsTileset = (cfg) => (
  cfg?.kind === 'points' || /_points$/i.test(String(cfg?.id || ''))
);

/**
 * Tilesets de puntos del índice: las entradas `*_points`, una por provincia.
 *
 * @param {Array<object>} indexConfigs entradas de `pmtiles_index.json`
 * @returns {Array<{id: string, province: string, url: string, bounds: number[], minzoom?: number, maxzoom?: number}>}
 */
export const getParcelPointsTilesets = (indexConfigs = []) => (
  Array.isArray(indexConfigs) ? indexConfigs.filter(isParcelPointsTileset) : []
);